import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=511e1d3a&scoped=true"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"
import style0 from "../../style/common-m.scss?vue&type=style&index=0&id=511e1d3a&prod&lang=scss&scoped=true&external"
import style1 from "./orderDetails.vue?vue&type=style&index=1&id=511e1d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511e1d3a",
  null
  
)

export default component.exports